import { createFileRoute } from "@tanstack/react-router";
import BlueShieldCaInsurance, { config } from "@/pages/BlueShieldCaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/blue-shield-ca-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Blue Shield CA TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Blue Shield of California policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Blue Shield CA TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Blue Shield of California policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/blue-shield-ca-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/blue-shield-ca-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BlueShieldCaInsurance />;
}
